import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import type { JobBoardRequisition } from '@/types'
import { createJobBoardItem } from '@/lib/api'
import { Card } from '@/components/ui/Card'
import { TextField, SaveBar } from '@/components/ui/FormFields'
import { PendingBackendNotice } from '@/components/ui/EmptyState'

export function JobBoardNew() {
  const navigate = useNavigate()
  const [agentName, setAgentName] = useState('')
  const [owner, setOwner] = useState('')
  const [saving, setSaving] = useState(false)
  const [result, setResult] = useState<string | null>(null)

  async function handleSave() {
    if (!agentName) {
      setResult('El nombre del agente propuesto es obligatorio')
      return
    }
    setSaving(true)
    setResult(null)
    try {
      const req: JobBoardRequisition = {
        id: `jd-${Date.now()}`,
        agent_name: agentName,
        status: 'borrador',
        owner,
        created_at: new Date().toISOString(),
        jd: '',
        spec: '',
      }
      await createJobBoardItem(req)
      navigate(`/job-board/${req.id}`)
    } catch (e) {
      setResult(e instanceof Error ? e.message : 'Error al crear')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div>
      <PendingBackendNotice endpoint="POST /job-board" />
      <h1 style={{ fontSize: 20, fontWeight: 500, marginBottom: 16 }}>Nueva requisición</h1>
      <Card style={{ maxWidth: 480 }}>
        <TextField label="Nombre del agente propuesto" value={agentName} onChange={setAgentName} />
        <TextField label="Owner" value={owner} onChange={setOwner} />
      </Card>
      <SaveBar onSave={handleSave} saving={saving} result={result} />
    </div>
  )
}
